<div class="item-container">
    <div class="item-header">
        <h5 class="text-center">Cost Calculator</h5>
        <div class="edit-icons" mat-dialog-close>
            <i class="material-icons">close</i>
        </div>
    </div>
    <div class="item-content d-flex flex-column justify-content-center">
        <form action="" [formGroup]="addForm">
            <div class="row">
                <div class="col-md-6 mt-3 mt-3 mt-lg-4">
                    <label for=""> {{"COMMON.STARTDATE"|translate}}</label>
                    <div class="in-box">
                        <input class="form-control" [matDatepicker]="startDate" formControlName="st_dt" readonly />
                        <mat-datepicker-toggle matIconSuffix [for]="startDate"></mat-datepicker-toggle>
                        <mat-datepicker #startDate></mat-datepicker>
                    </div>
                    <mat-error *ngIf="isControlHasError('st_dt','required')"> {{"COMMON.THR"|translate}}</mat-error>
                </div>
                <div class="col-md-6 mt-3 mt-lg-4">
                    <label for="">{{"COMMON.ENDDATE"|translate}}</label>
                    <div class="in-box">
                        <input class="form-control" [matDatepicker]="endDate" formControlName="ed_dt" readonly />
                        <mat-datepicker-toggle matIconSuffix [for]="endDate"></mat-datepicker-toggle>
                        <mat-datepicker #endDate></mat-datepicker>
                    </div>
                    <mat-error *ngIf="isControlHasError('ed_dt','required')"> {{"COMMON.THR"|translate}} </mat-error>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="mt-3">
                        <label for="">Category</label>
                        <mat-select class="form-control" placeholder="Select Category" formControlName="j_c" (selectionChange)="onSelectCategory($event)">
                            <mat-option *ngFor="let item of categoryArr" [value]="item.j_c">{{item.j_c}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="isControlHasError('j_c','required')"> {{"COMMON.THR"|translate}}</mat-error>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="mt-3">
                        <label for="">Sub Category</label>
                        <mat-select class="form-control" placeholder="Select Sub Category" formControlName="j_sc">
                            <mat-option *ngFor="let item of subCategoryArr" [value]="item.j_sc">{{item.j_sc}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="isControlHasError('j_sc','required')">{{"COMMON.THR"|translate}}</mat-error>
                    </div>
                </div>
            </div>
            <div class="mt-3">
                <label for="">Select User Type</label>
                <mat-radio-group class=" d-flex rd-box" formControlName="type">
                    <!-- if the user is recruiter then he can pull csv for company and employee -->
                    <!-- if the user is company then he can pull csv for the employees and recruiter -->
                    <div class="d-flex  rd-l" *ngIf="userType=='recruiter'">
                        <mat-radio-button class="" value="1"></mat-radio-button>
                        <div class="radio-title  l-h">Company</div>
                    </div>
                    <div class="d-flex ms-4 rd-l">
                        <mat-radio-button class="" value="2"></mat-radio-button>
                        <div class="radio-title  l-h">Employee</div>
                    </div>
                    <div class="d-flex" *ngIf="userType=='company'">
                        <mat-radio-button class="" value="3"></mat-radio-button>
                        <div class="radio-title l-h">Recruiter</div>
                    </div>
                </mat-radio-group>
                <mat-error *ngIf="isControlHasError('user_type','required')">{{"COMMON.THR"|translate}}</mat-error>
            </div>
            <div class="mt-3" *ngIf="addForm.get('type')?.value==1">
                <label for="">Company</label>
                <div class="mt-1">
                    <ng-select [items]="filterCmp" bindLabel="first_name" [searchFn]="customSearchFn" bindValue="em_i"
                        [multiple]="true" placeholder="Select Employee" [editableSearchTerm]="true"
                        formControlName="cmp" [closeOnSelect]="false" groupBy="e" [selectableGroup]="true" [selectableGroupAsModel]="false">
                        <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
                            <!-- as we are using this inside formGroup don't forget to add standalone true options as true -->
                            <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected" [ngModelOptions]="{standalone: true}" />
                            Select All
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <div class="d-flex align-items-center em-box">
                                <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected" [ngModelOptions]="{standalone: true}" class="me-2" />
                                <div class="u-img me-2" [appBackgroundImg]="item.profile_picture"></div>
                                <div> {{ item.first_name }} {{ item.last_name }}</div>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
            </div>
            <div class="mt-3" *ngIf="addForm.get('type')?.value==2">
                <label for="">Employee</label>
                <div class="mt-1">
                    <ng-select [items]="filterEmployeeArr" bindLabel="f_n" [searchFn]="customSearchFn" bindValue="em_i"
                        [multiple]="true" placeholder="Select Employee" [editableSearchTerm]="true"
                        formControlName="emp" [closeOnSelect]="false" groupBy="e" [selectableGroup]="true" [selectableGroupAsModel]="false">
                        <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
                            <!-- as we are using this inside formGroup don't forget to add standalone true options as true -->
                            <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected" [ngModelOptions]="{standalone: true}" />
                            Select All
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <div class="d-flex align-items-center em-box">
                                <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected" [ngModelOptions]="{standalone: true}" class="me-2" />
                                <div class="u-img me-2" [appBackgroundImg]="item.profile_picture"></div>
                                <div> {{ item.f_n}} {{ item.l_n }}</div>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
            </div>
            <div class="mt-3" *ngIf="addForm.get('type')?.value==3">
                <label for="">Recruiter</label>
                <div class="mt-1">
                    <ng-select [items]="filterRecArr" bindLabel="company_name" [searchFn]="customSearchFn"
                        bindValue="id" [multiple]="true" placeholder="Select Employee" [editableSearchTerm]="true"
                        formControlName="rec" [closeOnSelect]="false" groupBy="e" [selectableGroup]="true" [selectableGroupAsModel]="false">
                        <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
                            <!-- as we are using this inside formGroup don't forget to add standalone true options as true -->
                            <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected" [ngModelOptions]="{standalone: true}" /> Select All
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <div class="d-flex align-items-center em-box">
                                <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected" [ngModelOptions]="{standalone: true}" class="me-2" />
                                <div class="u-img me-2" [appBackgroundImg]="item.profile_picture"></div>
                                <div> {{ item.company_name }}</div>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
            </div>
        </form>
    </div>
    <div class="row">
        <div class="col-md-6 m-auto">
            <button mat-raised-button color="primary" class="auth-form-btn mt-3 mt-lg-4" type="submit" (click)="onSubmit(2)">Export PDF</button>
        </div>
        <div class="col-md-6 m-auto">
            <button mat-raised-button color="primary" class="auth-form-btn mt-3 mt-lg-4" type="submit" (click)="onSubmit(1)"> Export CSV</button>
        </div>
    </div>
</div>
<app-loading-spinner></app-loading-spinner>